/* Addon Product block — Horizon theme
   Vanilla JS. AJAX Cart API + Horizon cart drawer refresh. */
(function () {
  'use strict';

  const ROOT_ATTR = '[data-addon-product]';

  function getSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-drawer, cart-items, [id^="shopify-section"]').forEach((el) => {
      const id = el.dataset && el.dataset.sectionId ? el.dataset.sectionId : null;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function openCartDrawer() {
    // Horizon dispatches/consumes cart updates; refresh then open the drawer.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:update', { bubbles: true, detail: { source: 'addon-product' } })
    );

    const drawer =
      document.querySelector('cart-drawer-component') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('#cart-drawer');

    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    } else {
      const dialog = drawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      else drawer.setAttribute('open', '');
    }
  }

  function getSelectedVariantId(button, root) {
    const select = root.querySelector('[data-addon-variant-select]');
    if (select && select.value) return select.value;
    return button.dataset.variantId;
  }

  function syncVariant(root) {
    const select = root.querySelector('[data-addon-variant-select]');
    const button = root.querySelector('[data-addon-add]');
    if (!select || !button) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;

    const available = option.dataset.available === 'true';
    button.dataset.variantId = option.value;
    button.disabled = !available;

    const current = root.querySelector('.addon-product__price-current');
    const compare = root.querySelector('.addon-product__price-compare');
    if (current && option.dataset.price) {
      current.textContent = option.dataset.price;
      current.classList.toggle('addon-product__price-current--sale', !!option.dataset.comparePrice);
    }
    if (compare) {
      compare.textContent = option.dataset.comparePrice || '';
      compare.hidden = !option.dataset.comparePrice;
    }
  }

  async function addToCart(button, root) {
    const status = root.querySelector('[data-addon-status]');
    const variantId = getSelectedVariantId(button, root);
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';

    try {
      const body = {
        items: [{ id: Number(variantId), quantity: 1 }],
      };
      const sections = getSectionIds();
      if (sections.length) body.sections = sections.join(',');

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Unable to add to cart.');
      }

      document.dispatchEvent(
        new CustomEvent('cart:added', { bubbles: true, detail: { cart: data } })
      );
      openCartDrawer();
    } catch (error) {
      if (status) status.textContent = error.message || 'Something went wrong.';
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      syncVariant(root);
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-addon-add]');
    if (!button) return;
    const root = button.closest(ROOT_ATTR);
    if (!root) return;
    event.preventDefault();
    addToCart(button, root);
  });

  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-addon-variant-select]');
    if (!select) return;
    const root = select.closest(ROOT_ATTR);
    if (root) syncVariant(root);
  });

  function initAll() {
    document.querySelectorAll(ROOT_ATTR).forEach(syncVariant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
